import React from "react";
import ReactMarkdown from "react-markdown";

export default ({markdown}) => (<ReactMarkdown source={markdown} />);